import React, { ReactElement } from 'react';

const contentTextStyle: React.CSSProperties = {
    marginLeft: '6px',
};

interface AlertInfoProps {
    children: ReactElement | string;
    testId?: string | undefined;
}

export const AlertInfo: React.FC<AlertInfoProps> = ({ children, testId }) => {
    return (
        <div className="alert alert-primary" role="alert" data-testid={testId}>
            <span className="badge badge-pill badge-primary">
                <span className="oi oi-info"></span>
            </span>
            <span style={contentTextStyle}>{children}</span>
        </div>
    );
};
